<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1 style="margin-bottom: 0">Widgety</h1>

       </div>


        <div class="content content--widget" v-if="loaded">
            <div class="widgets">
                <div class="widgets__row">
                    <div class="widget">
                        <div class="widget__title">
                            Statistiky
                        </div>
                        <div class="widget__content">
                           <!-- <div class="widget-row">
                                <span class="widget-row__number">150</span>
                                dodavetelů
                            </div>-->
                            <div class="widget-row">
                                <span class="widget-row__number">{{formatThousands(stats.sold_audiobooks)}}</span>prodaných audioknih
                            </div>
                            <div class="widget-row">
                                <span class="widget-row__number">{{formatThousands(stats.paid_orders)}}</span>placených objednávek
                            </div>
                            <div class="widget-row">
                                <span class="widget-row__number">{{formatThousands(stats.average_order_price)}} Kč<span class="widget-number-sub">({{formatThousands(stats.average_order_price_no_dph)}} Kč bez DPH)</span></span>průměrná cena objednávky
                            </div>
                            <div class="widget-row">
                                <span class="widget-row__number">{{formatThousands(stats.money)}} Kč<span class="widget-number-sub">({{formatThousands(stats.money_no_dph)}} Kč bez DPH)</span></span>obrat za aktuální rok
                            </div>
                           <!-- <div class="widget-row">
                                <span class="widget-row__number">250 Kč<span class="widget-number-sub">(200 Kč bez DPH)</span></span>provize
                            </div>
-->
                        </div>
                    </div>
              <!--      <div class="widget">
                        widget
                    </div>-->
                </div>
            <!--    <div class="widgets__row">
                    <div class="widget">
                        widget
                    </div>
                    <div class="widget">
                        widget
                    </div>
                </div>-->


            </div>

        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Widgets',
        components: {
        },



        data() {
            return {
                loaded: false,
                stats: {}
            }
        },

        created() {

            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){

        },
        methods: {
            formatThousands(x) {
                return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            fetchData(){

                this.$axios.get('/admin/widgets/all').then((response) => {
                    this.stats = response.data.widgets.stats;
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });
            }

        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
